import React, { useState } from 'react';
import { Image, ImageBackground, View } from 'react-native';
import { ActivityIndicator, Colors } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { Header } from '../../../components/common';
import { AppButton } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import { getPlanData } from '../../../redux/actions/workerActions';
import { WorkerActions } from '../../../redux/reducers/workerReducer';
import { API } from '../../../service/api';
import { uploadAvatar } from '../../../service/upload';
import styles from './styles';

const AlterPic = ({ navigation }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { workerData } = useSelector((state) => state.worker);

  const submitAvatar = async () => {
    await uploadAvatar('worker', workerData.id_colaborador, setLoading);
    API.get(`/get/colaborador/${workerData.id_colaborador}`).then((response) => {
      dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'workerData', dataValue: response.data.data[0] });
      dispatch(getPlanData(response.data.data[0].id_colaborador, navigation));
    });
  };

  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <Header navigation={navigation} profilePic={workerData.foto} userName={workerData.nome} />
      <View style={styles.content}>
        {loading ? (<ActivityIndicator color="#FFF" size={pixelDimensions(7)} />) : (
          <>
            <Image source={{ uri: workerData.foto }} style={styles.imageChangePicBigger} />
            <AppButton size="bold" label="ALTERAR FOTO DE PERFIL" labelStyle={styles.textButtonAlterPic} onPress={submitAvatar} style={styles.buttonAlterPic} />
            <AppButton size="bold" label="ALTERAR SENHA" labelStyle={styles.textButtonAlterPic} onPress={() => navigation.navigate('Worker Alter Password')} style={styles.buttonAlterPic} />
            <AppButton size="bold" label="ALTERAR DADOS PESSOAIS" labelStyle={styles.textButtonAlterPic} onPress={() => navigation.navigate('Worker Alter Data')} style={styles.buttonAlterPic} />
          </>
        )}
      </View>
      <AppButton size="bold" label="VOLTAR" rippleColor={Colors.indigo700} style={styles.buttonBack} labelStyle={styles.textBack} onPress={() => navigation.goBack()} />
    </ImageBackground>
  );
};

export default AlterPic;
